import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import RedirectionBlockData from '../../../Models/Content/RedirectionBlockData';
import Redirection from './RedirectionBlock';

export default class RedirectionBlock extends EpiComponent<RedirectionBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['redirection-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <Redirection iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}
